<template>
  <div style="height: 100%; padding: 20px">
    <el-card style="height: 100%">
      <div class="wrapper">
        <ul class="left">
          <li
            v-for="(item, index) in list"
            :key="index"
            @click="changeItem(item, index)"
            :class="current == index ? 'active' : ''"
          >
            {{ item.typeName }}
          </li>
          <li>
            <i
              class="el-icon-circle-plus-outline"
              @click="addFather"
              style="font-size: 20px"
            ></i>
          </li>
        </ul>
        <div class="right">
          <el-button size="mini" type="primary" plain @click="addType"
            >添加二级分类</el-button
          >
          <div v-for="(i, ind) in secondList" :key="ind" class="box">
            <p>
              {{ i.typeName }}

              <i
                class="el-icon-edit"
                style="margin-left: 10px"
                @click="editTypeName(i)"
              ></i>
            </p>
            <div class="right_item">
              <dl v-for="(x, y) in i.childList" :key="y">
                <dd>
                  <img :src="x.imgUrl" alt="" />
                  <i class="el-icon-edit edit" @click="editChild(x)"></i>
                </dd>
                <dt>{{ x.typeName }}</dt>
              </dl>
              <dl style="text-align: left">
                <i
                  class="el-icon-circle-plus-outline"
                  style="font-size: 40px; margin-top: 25px"
                  @click="addSecond(i)"
                ></i>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <!-- 添加三级 -->
    <a-modal v-model="secondModel" title="添加三级" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="分类名称">
          <el-col :span="10">
            <el-input v-model="typeName" placeholder="请输入内容"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="选择图片">
          <el-upload
            class="avatar-uploader"
            name="img"
            :action="serverUrl"
            :headers="header"
            :auto-upload="true"
            :show-file-list="false"
            :on-success="upSuccess"
          >
            <img
              v-if="imgUrl"
              :src="imgUrl"
              class="avatar"
              style="width: 150px; height: auto"
            />

            <i
              :class="
                loadUpt
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px"
              v-else
            ></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="sureAddSecond"
        >确定</el-button
      >
    </a-modal>
    <a-modal v-model="fatherModel" title="添加" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="分类名称">
          <el-col :span="10">
            <el-input
              v-model="fatherTypeName"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="sureAddFather"
        >确定</el-button
      >
    </a-modal>
    <!-- 修改三级 -->
    <a-modal v-model="editChildModel" title="修改三级" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="分类名称">
          <el-col :span="10">
            <el-input
              v-model="editChildList.typeName"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="选择图片">
          <el-upload
            class="avatar-uploader"
            name="img"
            :action="serverUrl"
            :headers="header"
            :auto-upload="true"
            :show-file-list="false"
            :on-success="editSuccess"
          >
            <img
              v-if="editChildList.imgUrl"
              :src="editChildList.imgUrl"
              class="avatar"
              style="width: 150px; height: auto"
            />

            <i
              :class="
                loadUpt
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px"
              v-else
            ></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="sureEditChildList"
        >确定</el-button
      >
    </a-modal>
    <!-- 修改二级 -->
    <a-modal v-model="editModel" title="修改二级" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="分类名称">
          <el-col :span="10">
            <el-input
              v-model="editList.typeName"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="sureEditList"
        >确定</el-button
      >
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  data() {
    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        // token: localStorage.getItem("key"),
      },
      tabPosition: "left",
      list: [],
      typeName: "",
      fatherTypeName: "",
      secondId: "",
      secondModel: false,
      fatherModel: false,
      editChildModel: false,
      editModel: false,
      secondList: [],
      imgUrl: "",
      current: 0,
      fatherId: "",
      editChildList: {
        imgUrl: "",
        typeName: "",
        id: "",
      },
      editList: {
        typeName: "",
        id: "",
      },
    };
  },
  methods: {
    getList() {
      this.getAxios("/scType/list", {
        // fid: 0,
      }).then((res) => {
        if (res.success) {
          this.list = res.content;
          this.secondList = res.content[this.current].childList;
          this.fatherId = res.content[this.current].id;
        } else {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    changeItem(item, index) {
      this.current = index;
      this.secondList = item.childList;
      this.fatherId = item.id;
    },
    // 添加二级
    addSecond(item) {
      this.secondModel = true;
      this.secondId = item.id;
    },
    addFather() {
      this.fatherModel = true;
      this.fatherId = 0;
    },
    addType() {
      this.fatherModel = true;
    },
    sureAddSecond() {
      this.postAxios("/scType/insert", {
        typeName: this.typeName,
        fatherId: this.secondId,
        imgUrl: this.imgUrl,
      }).then((res) => {
        if (res.success) {
          this.secondModel = false;
          this.$message.success(res.message);
          this.imgUrl = "";
          this.typeName = "";
          this.getList();
        }
      });
    },
    sureAddFather() {
      this.postAxios("/scType/insert", {
        typeName: this.fatherTypeName,
        fatherId: this.fatherId,
      }).then((res) => {
        if (res.success) {
          this.fatherModel = false;
          this.$message.success(res.message);
          this.imgUrl = "";
          this.fatherTypeName = "";
          this.getList();
        }
      });
    },
    // 修改二级名称
    editTypeName(item) {
      this.editModel = true;
      this.editList = {
        typeName: item.typeName,
        id: item.id,
      };
    },
    // 修改三级
    editChild(item) {
      this.editChildModel = true;
      this.editChildList = {
        imgUrl: item.imgUrl,
        typeName: item.typeName,
        id: item.id,
      };
    },
    // 修改三级
    sureEditChildList() {
      this.postAxios("/scType/update", {
        id: this.editChildList.id,
        typeName: this.editChildList.typeName,
        imgUrl: this.editChildList.imgUrl,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.editChildModel = false;
          this.getList();
        }
      });
    },
    sureEditList() {
      this.postAxios("/scType/update", {
        id: this.editList.id,
        typeName: this.editList.typeName,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.editModel = false;
          this.getList();
        }
      });
    },
    upSuccess(file) {
      this.imgUrl = file.entity;
    },
    editSuccess(file) {
      this.editChildList.imgUrl = file.entity;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}
.left {
  width: 150px;
  text-align: center;
  background: rgb(246, 246, 246);
}
.left li {
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.right {
  padding: 9px 30px 0;
  background: #fff;
  flex: 1;
  overflow-y: scroll;
}
.right p {
  font-weight: bold;
}
.right_item {
  display: flex;
  flex-wrap: wrap;
}
.right_item dl {
  width: 130px;
  height: 140px;
  text-align: center;
  margin: 0 40px 0 0;
  position: relative;
}
.box {
  margin-top: 20px;
  border-bottom: 1px dashed #ccc;
}
.box:last-child {
  border: 0;
}
// .right_item dl dd {
//   height: 80px;
// }
.active {
  background: #fff;
  font-size: 14px;
  font-weight: bold;
}
dd img {
  width: 130px;
  height: 90px;
}
.edit {
  position: absolute;
}
/deep/ .el-card__body {
  height: 100%;
  background: rgb(246, 246, 246);
  padding: 0 !important;
}
/deep/ .el-card {
  height: 100%;
}
/deep/.el-upload {
  width: 200px;
  height: auto;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
  img {
    width: 100%;
    height: auto;
  }
}
</style>